<app-add-form
  data-testid="virtual-warehouse-form-add-form"
  #addForm
  [title]="formConfig().title"
  [formFields]="formConfig().formFields"
  [headerActions]="formConfig().headerActions"
  [tableSections]="formConfig().tableSections"
  [initialData]="warehouseData()"
  [loading]="loading()"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
  (tableAction)="onTableAction($event)"
>
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      <p-button
        [attr.data-testid]="
          'virtual-warehouse-form-physical-warehouse-view-btn-' + rowData.id
        "
        size="small"
        [label]="'common.actions.view' | translate"
        severity="info"
        (onClick)="onPhysicalWarehouseTableActionClick('view', rowData)"
        text
      ></p-button>
    </div>
  </ng-template>
</app-add-form>

<app-selection-dialog
  data-testid="virtual-warehouse-form-selection-dialog"
  [visible]="showWarehouseDialog()"
  [config]="dialogConfig()"
  [items]="dialogWarehouses()"
  [loading]="dialogLoading()"
  [totalRecords]="dialogTotalRecords()"
  [initialSelection]="dialogInitialSelection()"
  (visibleChange)="showWarehouseDialog.set($event)"
  (selectionConfirm)="onDialogSelectionConfirm($event)"
  (search)="onDialogSearch($event)"
  (searchReset)="onDialogSearchReset()"
>
  <ng-template #warehouseType let-row>
    {{ getWarehouseTypeLabel(row) }}
  </ng-template>
</app-selection-dialog>

<p-toast data-testid="virtual-warehouse-form-toast" position="top-right"></p-toast>
